/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type LoginFormSendTokenMutationVariables = {|
  email: string,
  code?: ?number,
|};
export type LoginFormSendTokenMutationResponse = {|
  +sendToken: ?{|
    +ok: boolean
  |}
|};
export type LoginFormSendTokenMutation = {|
  variables: LoginFormSendTokenMutationVariables,
  response: LoginFormSendTokenMutationResponse,
|};
*/


/*
mutation LoginFormSendTokenMutation(
  $email: String!
  $code: Int
) {
  sendToken(email: $email, code: $code) {
    ok
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "email",
    "type": "String!"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "code",
    "type": "Int"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "code",
        "variableName": "code"
      },
      {
        "kind": "Variable",
        "name": "email",
        "variableName": "email"
      }
    ],
    "concreteType": "SendTokenMutation",
    "kind": "LinkedField",
    "name": "sendToken",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "LoginFormSendTokenMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "LoginFormSendTokenMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "LoginFormSendTokenMutation",
    "operationKind": "mutation",
    "text": "mutation LoginFormSendTokenMutation(\n  $email: String!\n  $code: Int\n) {\n  sendToken(email: $email, code: $code) {\n    ok\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'c683242f5d1c07b59a23df7f32e54f75';

module.exports = node;
